var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLobbyReservation = function SvgLobbyReservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lobby_reservation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.475 0H7.525A7.525 7.525 0 0 0 0 7.525v12.95A7.525 7.525 0 0 0 7.525 28h12.95A7.525 7.525 0 0 0 28 20.475V7.525A7.525 7.525 0 0 0 20.475 0Z",
    fill: "#8E73F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.867A5.14 5.14 0 0 1 19.133 14c0 2.823-2.31 5.133-5.133 5.133S8.867 16.823 8.867 14 11.177 8.867 14 8.867Zm0-2.334A7.466 7.466 0 1 0 14 21.466 7.466 7.466 0 0 0 14 6.533Z",
    fill: "#D4CBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.555 15.167H14.21A1.17 1.17 0 0 1 13.043 14v-2.322a1.17 1.17 0 0 1 1.167-1.166 1.17 1.17 0 0 1 1.166 1.166v1.155h1.179A1.17 1.17 0 0 1 17.72 14a1.17 1.17 0 0 1-1.166 1.167Z",
    fill: "#D4CBF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lobby_reservation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgLobbyReservation;